import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { lotusDarkLogo, blurflower } from '@/shared/assets';

interface LoginShellProps {
  children: ReactNode;
  contentClassName?: string;
}

export function LoginShell({ children, contentClassName }: LoginShellProps) {
  const resolvedContentClassName = contentClassName ?? 'items-center justify-center';

  return (
    <div className="dark relative h-dvh w-full overflow-hidden bg-background text-foreground">
      <img
        src={blurflower}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />

      <div className="relative flex h-full min-h-0 w-full flex-col sm:w-[33%] sm:min-w-[340px]">
        <div className="p-10">
          <Link to="/" aria-label="Go to home">
            <img src={lotusDarkLogo} alt="Lotus Health" className="w-12" />
          </Link>
        </div>

        <div className={`flex min-h-0 flex-1 ${resolvedContentClassName}`}>{children}</div>
      </div>
    </div>
  );
}
